import { render, staticRenderFns } from "./footerMain.vue?vue&type=template&id=4e4051fc&"
import script from "./footerMain.vue?vue&type=script&lang=js&"
export * from "./footerMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports